import Icon from "../Icon";

export function List({ children }) {
  return <div className="grid gap-3">{children}</div>;
}

export function ListHeader({ name, description }: { name: string; description: string }) {
  return (
    <div className="grid gap-0.5">
      <h2 className="m-0 text-base font-semibold">{name}</h2>
      <p className="m-0">{description}</p>
    </div>
  );
}

export function ListContent({ children }) {
  return (
    <div className="divide-y divide-gray overflow-clip rounded shadow-depth-200">{children}</div>
  );
}

export function ListItem({
  name,
  description,
  icon = "custom/outline/pipeline",
  onClick,
}: {
  name: string;
  description: string;
  icon?: string;
  onClick: () => void;
}) {
  return (
    <div onClick={onClick} className="flex cursor-pointer items-center gap-2 px-2 py-3">
      <div className="flex size-10 shrink-0 items-center justify-center self-start rounded bg-gray-200">
        <Icon className="size-6" icon={icon} />
      </div>

      <div className="grid gap-0.5">
        <h3 className="m-0 text-sm font-medium">{name}</h3>
        <p className="m-0 line-clamp-2 text-[13px] leading-snug text-charcoal-300">{description}</p>
      </div>

      <Icon
        icon="heroicons/20/solid/chevron-right"
        className="size-5 flex-none text-charcoal-300"
      />
    </div>
  );
}
